import { route, tag, type PageTour } from '../pageTour';

export const allSitesLiveWallTour: PageTour = {
  id: 'page-all-sites-live-wall',
  version: 1,
  title: 'All Sites Live Wall',
  summary: 'Watch cameras from several sites side by side.',
  match: route('/all-sites/live-wall'),
  steps: [
    {
      target: tag('all-sites-wall-layouts'),
      title: 'Layouts',
      description: 'Pick a saved layout to put on the wall. A layout can mix cameras from any of your sites.',
      side: 'bottom',
    },
    {
      target: tag('all-sites-wall-new-layout'),
      title: 'New layout',
      description: 'Build a new wall: choose a grid, then click a window to add a camera to it.',
      side: 'bottom',
      permission: 'multi-site.edit',
    },
    {
      target: tag('all-sites-wall-latency'),
      title: 'Network latency',
      description: 'Show how quickly each site is responding, on top of its cameras. Handy when video looks slow.',
      side: 'bottom',
    },
    {
      target: tag('all-sites-wall-fullscreen'),
      title: 'Fullscreen',
      description: 'Fill the whole screen with the wall, for a control room display.',
      side: 'bottom',
    },
    {
      target: tag('all-sites-wall-grid'),
      title: 'The wall',
      description: 'Live video from every camera in the layout. Double-click a camera to enlarge it, and hover for quick actions like playback.',
      side: 'top',
    },
  ],
};
